export default __webpack_public_path__ + "static/media/jawalat1.ab2679bc.png";